export default function pdfEmbed() {
  const pdfPlaceholders = document.querySelectorAll('.pdf-embed__placeholder');
  
  if (pdfPlaceholders.length === 0) {
    return;
  }
  
  pdfPlaceholders.forEach(placeholder => {
    const pdfUrl = placeholder.getAttribute('data-pdf-url');
    
    if (!pdfUrl) {
      return;
    }
    
    // Create the embed element
    const embedElement = document.createElement('div');
    embedElement.innerHTML = `<embed src="${pdfUrl}#toolbar=0" type="application/pdf" width="100%" height="976px"></embed>`;
    
    // Replace the placeholder with the embed
    placeholder.parentNode.replaceChild(embedElement.firstChild, placeholder);
  });
}